import { currencyMenuStyles } from "@insite/content-library/Widgets/Common/CurrencyMenu";
import { css } from "styled-components";



currencyMenuStyles.currencySymbol = {
    size: 22,
    css: css`
        margin-top: 3px;
        width: 100px;
        text-align: end;
    `,
};
